function qinticInOut(t) {
    if ( ( t *= 2 ) < 1 ) return 0.5 * t * t * t * t * t
    return 0.5 * ( ( t -= 2 ) * t * t * t * t + 2 )
}

module.exports = qinticInOut


//////////////////
// WEBPACK FOOTER
// ../node_modules/eases/quint-in-out.js
// module id = 112
// module chunks = 0